import { defineComponent as T, computed as p, defineAsyncComponent as n, openBlock as I, createBlock as l, resolveDynamicComponent as a } from "vue";
const u = /* @__PURE__ */ T({
  __name: "TnIcon",
  props: {
    name: {},
    color: { default: "currentColor" },
    size: { default: "m" }
  },
  setup(e) {
    const o = e, t = p(() => o.size === "xs" ? "16px" : o.size === "s" ? "20px" : o.size === "m" ? "22px" : o.size === "l" ? "26px" : o.size === "xl" ? "28px" : o.size === "2xl" ? "32px" : "22px"), r = {
      TnIcon0: n(() => import("./TnIcon0-BiXzZAuw.js")),
      TnIcon0Filled: n(() => import("./TnIcon0-filled-DfMUaoYe.js")),
      TnIcon0Outline: n(() => import("./TnIcon0-outline-CZ7J6MZz.js")),
      TnIcon1: n(() => import("./TnIcon1-IWMvetSI.js")),
      TnIcon1Filled: n(() => import("./TnIcon1-filled-Db64uh82.js")),
      TnIcon1Outline: n(() => import("./TnIcon1-outline-CrE2F1ce.js")),
      TnIcon2: n(() => import("./TnIcon2-qS_-O-Sb.js")),
      TnIcon2Filled: n(() => import("./TnIcon2-filled-9WfzQ4th.js")),
      TnIcon2Outline: n(() => import("./TnIcon2-outline-BwrnRbi7.js")),
      TnIcon3: n(() => import("./TnIcon3-CNz0fKvf.js")),
      TnIcon3Filled: n(() => import("./TnIcon3-filled-DgvMxYH9.js")),
      TnIcon3Outline: n(() => import("./TnIcon3-outline-CKXL6ZWn.js")),
      TnIcon4: n(() => import("./TnIcon4-vDOLPt0u.js")),
      TnIcon4Filled: n(() => import("./TnIcon4-filled-W7QD77QG.js")),
      TnIcon4Outline: n(() => import("./TnIcon4-outline-CK1ueset.js")),
      TnIcon5: n(() => import("./TnIcon5-CTs41GuD.js")),
      TnIcon5Filled: n(() => import("./TnIcon5-filled-wQuCValF.js")),
      TnIcon5Outline: n(() => import("./TnIcon5-outline-DGBnWJyT.js")),
      TnIcon6: n(() => import("./TnIcon6-Bj1TCvbC.js")),
      TnIcon60DayFreeReturns: n(() => import("./TnIcon60-day-free-returns-DKI9haOx.js")),
      TnIcon6Filled: n(() => import("./TnIcon6-filled-nfJKHmyQ.js")),
      TnIcon6Outline: n(() => import("./TnIcon6-outline-DGVCkkcV.js")),
      TnIcon7: n(() => import("./TnIcon7-BTcWk46L.js")),
      TnIcon7Filled: n(() => import("./TnIcon7-filled-CG8I2FSB.js")),
      TnIcon7Outline: n(() => import("./TnIcon7-outline-7-1PjeL6.js")),
      TnIcon8: n(() => import("./TnIcon8-Czad5cum.js")),
      TnIcon8Filled: n(() => import("./TnIcon8-filled-Gsmk9hvJ.js")),
      TnIcon8Outline: n(() => import("./TnIcon8-outline-7apYbcs0.js")),
      TnIcon9: n(() => import("./TnIcon9-DkVN1Vmi.js")),
      TnIcon9Filled: n(() => import("./TnIcon9-filled-BUgQ2KRO.js")),
      TnIcon9Outline: n(() => import("./TnIcon9-outline-DUcY8Rar.js")),
      TnIconAccount: n(() => import("./TnIconaccount-C4YO3T4O.js")),
      TnIconAltRoute: n(() => import("./TnIconalt-route-BwBOfCu8.js")),
      TnIconAntenna: n(() => import("./TnIconantenna-DNgA4xkr.js")),
      TnIconAppleAirplay: n(() => import("./TnIconapple-airplay-DzdAGFCk.js")),
      TnIconApps: n(() => import("./TnIconapps-B2aoO5Wf.js")),
      TnIconAt: n(() => import("./TnIconat-PfHZLtNK.js")),
      TnIconAttentionCircleFilled: n(() => import("./TnIconattention-circle-filled-9lAdRqNn.js")),
      TnIconAttentionCircleOutline: n(() => import("./TnIconattention-circle-outline-CWTG1PGV.js")),
      TnIconBackspace: n(() => import("./TnIconbackspace-DwkqqrKn.js")),
      TnIconBackspaceFilled: n(() => import("./TnIconbackspace-filled-DcTd_abW.js")),
      TnIconBankID: n(() => import("./TnIconbank-id-xxxx9i-x.js")),
      TnIconBankIDApp: n(() => import("./TnIconbank-id-app-BuMV6ZMM.js")),
      TnIconBankIDAppNegative: n(() => import("./TnIconbank-id-app-negative-yZjS1RvE.js")),
      TnIconBatteryCharging: n(() => import("./TnIconbattery-charging-W-_ZLVyC.js")),
      TnIconBatteryEmpty: n(() => import("./TnIconbattery-empty-CNJQDJm0.js")),
      TnIconBatteryFull: n(() => import("./TnIconbattery-full-BczJSFr6.js")),
      TnIconBatteryHalf: n(() => import("./TnIconbattery-half-y9fqwL7K.js")),
      TnIconBatteryLow: n(() => import("./TnIconbattery-low-Be-3uncv.js")),
      TnIconBatteryQuarter: n(() => import("./TnIconbattery-quarter-DHWMp-an.js")),
      TnIconBills: n(() => import("./TnIconbills-C4rSDebV.js")),
      TnIconBookmarkFilled: n(() => import("./TnIconbookmark-filled-DyZ2ve5K.js")),
      TnIconBookmarkOutline: n(() => import("./TnIconbookmark-outline-CrdHIZo2.js")),
      TnIconBookmarks: n(() => import("./TnIconbookmarks-Dp64GzIQ.js")),
      TnIconBranch: n(() => import("./TnIconbranch-DXgmM92X.js")),
      TnIconBullet: n(() => import("./TnIconbullet-BGVVgJfs.js")),
      TnIconBulletOutline: n(() => import("./TnIconbullet-outline-C1aDKSWp.js")),
      TnIconBullhorn: n(() => import("./TnIconbullhorn-Cam_UCwf.js")),
      TnIconBusiness: n(() => import("./TnIconbusiness-CHhzf3n2.js")),
      TnIconCalendar: n(() => import("./TnIconcalendar-khMwMMkP.js")),
      TnIconCallEnd: n(() => import("./TnIconcall-end-65IsB173.js")),
      TnIconCallForwarded: n(() => import("./TnIconcall-forwarded-Bv3XXhAE.js")),
      TnIconCallForwardedFilled: n(() => import("./TnIconcall-forwarded-filled-BSMSbgNT.js")),
      TnIconCallIncoming: n(() => import("./TnIconcall-incoming-DKBt8e5F.js")),
      TnIconCallIncomingFilled: n(() => import("./TnIconcall-incoming-filled-Dx9XVAn0.js")),
      TnIconCallInUse: n(() => import("./TnIconcall-in-use-8bENHXse.js")),
      TnIconCallInUseFilled: n(() => import("./TnIconcall-in-use-filled-B5ea7J69.js")),
      TnIconCallMissed: n(() => import("./TnIconcall-missed-DkuDknm3.js")),
      TnIconCallMissedFilled: n(() => import("./TnIconcall-missed-filled-DseX4d12.js")),
      TnIconCallOff: n(() => import("./TnIconcall-off-VvdQplfo.js")),
      TnIconCallOffFilled: n(() => import("./TnIconcall-off-filled-D-329B3G.js")),
      TnIconCallOutgoing: n(() => import("./TnIconcall-outgoing-FYlJAXs9.js")),
      TnIconCallOutgoingFilled: n(() => import("./TnIconcall-outgoing-filled-BpjkS8bc.js")),
      TnIconCallPause: n(() => import("./TnIconcall-pause-DTSDFz4J.js")),
      TnIconCallPauseFilled: n(() => import("./TnIconcall-pause-filled-5A9AqxC6.js")),
      TnIconCamera: n(() => import("./TnIconcamera-B7mtSCH5.js")),
      TnIconCart: n(() => import("./TnIconcart-5h5eo7XV.js")),
      TnIconCartNewItem: n(() => import("./TnIconcart-new-item-DIb64S8t.js")),
      TnIconCatchUp: n(() => import("./TnIconcatch-up-DSsR2_LW.js")),
      TnIconChart: n(() => import("./TnIconchart-QNe9kaz6.js")),
      TnIconCheckboxChecked: n(() => import("./TnIconcheckbox-checked-lMn16p89.js")),
      TnIconCheckboxUnchecked: n(() => import("./TnIconcheckbox-unchecked-6_OhUzmS.js")),
      TnIconChevronDown: n(() => import("./TnIconchevron-down-CsggIfHs.js")),
      TnIconChevronLeft: n(() => import("./TnIconchevron-left-D3VXMm9Y.js")),
      TnIconChevronRight: n(() => import("./TnIconchevron-right-BVyUorFs.js")),
      TnIconChevronsDown: n(() => import("./TnIconchevrons-down-CfFjfq9b.js")),
      TnIconChevronsLeft: n(() => import("./TnIconchevrons-left-CXcBOKxW.js")),
      TnIconChevronsRight: n(() => import("./TnIconchevrons-right-DrSU3TVN.js")),
      TnIconChevronsUp: n(() => import("./TnIconchevrons-up-DxuWXa__.js")),
      TnIconChevronUp: n(() => import("./TnIconchevron-up-C5XW-2r2.js")),
      TnIconChild1: n(() => import("./TnIconchild-1-8sw6XzbU.js")),
      TnIconChild2: n(() => import("./TnIconchild-2-DzjZubPk.js")),
      TnIconChromecastOff: n(() => import("./TnIconchromecast-off-B38XizCV.js")),
      TnIconChromecastOn: n(() => import("./TnIconchromecast-on-DqPOAMHT.js")),
      TnIconClock: n(() => import("./TnIconclock-DyKbFR0U.js")),
      TnIconClose: n(() => import("./TnIconclose-BxJd6vJS.js")),
      TnIconClosePanelLeft: n(() => import("./TnIconclose-panel-left-B516FTxZ.js")),
      TnIconClosePanelRight: n(() => import("./TnIconclose-panel-right-4GeecC3z.js")),
      TnIconCloudDownload: n(() => import("./TnIconcloud-download-COQ44bQl.js")),
      TnIconCloudUpload: n(() => import("./TnIconcloud-upload-2ge0eaQD.js")),
      TnIconCoins: n(() => import("./TnIconcoins-DqhYpbyb.js")),
      TnIconCollapse: n(() => import("./TnIconcollapse-DPCsngf9.js")),
      TnIconConnected: n(() => import("./TnIconconnected-DTicjO67.js")),
      TnIconContentSwitcher: n(() => import("./TnIconcontent-switcher-C0-gB9aS.js")),
      TnIconContractScreen: n(() => import("./TnIconcontract-screen-CDtQsOAY.js")),
      TnIconCookie: n(() => import("./TnIconcookie-zbKJcqoU.js")),
      TnIconCopy: n(() => import("./TnIconcopy-BCjzLEyR.js")),
      TnIconCreditCard: n(() => import("./TnIconcredit-card-Cc0aYXYD.js")),
      TnIconCriticalFilled: n(() => import("./TnIconcritical-filled-f-3vetV0.js")),
      TnIconCriticalOutline: n(() => import("./TnIconcritical-outline-Blv2s-up.js")),
      TnIconCtaLeft: n(() => import("./TnIconcta-left-LTEZbUbe.js")),
      TnIconCtaRight: n(() => import("./TnIconcta-right-DpT2Hgvk.js")),
      TnIconCustomerService: n(() => import("./TnIconcustomer-service-DPmTEz-I.js")),
      TnIconDashboard: n(() => import("./TnIcondashboard-Dd1LW9FT.js")),
      TnIconDelete: n(() => import("./TnIcondelete-BMzgIJ78.js")),
      TnIconDeleteFilled: n(() => import("./TnIcondelete-filled-CO-n9V5P.js")),
      TnIconDelivery: n(() => import("./TnIcondelivery-BrNQ4i4Q.js")),
      TnIconDeliveryExpress: n(() => import("./TnIcondelivery-express-jNbdhC_N.js")),
      TnIconDevices: n(() => import("./TnIcondevices-R7Lr2PBH.js")),
      TnIconDiagonalDownLeft: n(() => import("./TnIcondiagonal-down-left-DCKsBfn3.js")),
      TnIconDiagonalDownRight: n(() => import("./TnIcondiagonal-down-right-DnAP9DlK.js")),
      TnIconDiagonalUpLeft: n(() => import("./TnIcondiagonal-up-left-BX6U5615.js")),
      TnIconDiagonalUpRight: n(() => import("./TnIcondiagonal-up-right-DBOlxR02.js")),
      TnIconDiscount: n(() => import("./TnIcondiscount-BxlCZlX7.js")),
      TnIconDocument: n(() => import("./TnIcondocument-CV779bb1.js")),
      TnIconDocumentAdd: n(() => import("./TnIcondocument-add-DmnFWHtT.js")),
      TnIconDocumentDelete: n(() => import("./TnIcondocument-delete-CezwrpLJ.js")),
      TnIconDocumentDetails: n(() => import("./TnIcondocument-details-CAD-gYiz.js")),
      TnIconDolbyDigital: n(() => import("./TnIcondolby-digital-D0HalVcD.js")),
      TnIconDown: n(() => import("./TnIcondown-DR_-WfrK.js")),
      TnIconDownloadCircle: n(() => import("./TnIcondownload-circle-BzKVtu6H.js")),
      TnIconDownloadCompleteTray: n(() => import("./TnIcondownload-complete-tray-NPC-H678.js")),
      TnIconDownloadProgressCircle: n(() => import("./TnIcondownload-progress-circle-5CHQQKq7.js")),
      TnIconDownloadToBox: n(() => import("./TnIcondownload-to-box-BrsnarbO.js")),
      TnIconDownloadTray: n(() => import("./TnIcondownload-tray-BPWsZXFy.js")),
      TnIconDragDots: n(() => import("./TnIcondrag-dots-UlcfgieV.js")),
      TnIconDragHandleHorisontal: n(() => import("./TnIcondrag-handle-horisontal-DbMW14te.js")),
      TnIconDragHandleVertical: n(() => import("./TnIcondrag-handle-vertical-3vW2lBYe.js")),
      TnIconEdit: n(() => import("./TnIconedit-Ddmk-ooa.js")),
      TnIconEmail: n(() => import("./TnIconemail-BVUW-rMJ.js")),
      TnIconEmployee: n(() => import("./TnIconemployee-BE7MLEu_.js")),
      TnIconErrorCircleFilled: n(() => import("./TnIconerror-circle-filled-nb_XdUZ1.js")),
      TnIconErrorCircleOutline: n(() => import("./TnIconerror-circle-outline-khuA1X2o.js")),
      TnIconeSim: n(() => import("./TnIcone-sim-yYobRqDo.js")),
      TnIconEthernet: n(() => import("./TnIconethernet-oGe3UVt8.js")),
      TnIconExpand: n(() => import("./TnIconexpand-BUsWOE_F.js")),
      TnIconExpandInputBox: n(() => import("./TnIconexpand-input-box-Ctp8CtAH.js")),
      TnIconExpandScreen: n(() => import("./TnIconexpand-screen-Ds-Xh2YC.js")),
      TnIconExpressDelivery: n(() => import("./TnIconexpress-delivery-9EZWZnad.js")),
      TnIconExternalLink: n(() => import("./TnIconexternal-link-BgZtasP5.js")),
      TnIconEyeClosed: n(() => import("./TnIconeye-closed-INUBt5TF.js")),
      TnIconEyeOff: n(() => import("./TnIconeye-off-DnknuwdT.js")),
      TnIconEyeOpen: n(() => import("./TnIconeye-open-DY6-QaJZ.js")),
      TnIconFacebook: n(() => import("./TnIconfacebook-l_5VGElq.js")),
      TnIconFaceID: n(() => import("./TnIconface-id-23qR3HjH.js")),
      TnIconFamily: n(() => import("./TnIconfamily-Dyp9w5uU.js")),
      TnIconFigma: n(() => import("./TnIconfigma-B0Wu71Br.js")),
      TnIconFigmaOutline: n(() => import("./TnIconfigma-outline-BdHIh6bm.js")),
      TnIconFilter: n(() => import("./TnIconfilter-veIeL6el.js")),
      TnIconFingerprint: n(() => import("./TnIconfingerprint-CyNhcz81.js")),
      TnIconFlagFilled: n(() => import("./TnIconflag-filled-Ce4ZVzbb.js")),
      TnIconFlagOutline: n(() => import("./TnIconflag-outline-cRxJkFbY.js")),
      TnIconFloppy: n(() => import("./TnIconfloppy-BEraoSIX.js")),
      TnIconFolder: n(() => import("./TnIconfolder-xpJE4en3.js")),
      TnIconFolderAdd: n(() => import("./TnIconfolder-add-B071Z5WL.js")),
      TnIconFolders: n(() => import("./TnIconfolders-B3AY_MSf.js")),
      TnIconFreeDeliveryAndReturns: n(() => import("./TnIconfree-delivery-and-returns-DaBwICCS.js")),
      TnIconFullScreen: n(() => import("./TnIconfull-screen-DBuFXCMc.js")),
      TnIconGift: n(() => import("./TnIcongift-BWsfz4FG.js")),
      TnIconGithub: n(() => import("./TnIcongithub-B92ewmIe.js")),
      TnIconGlobe: n(() => import("./TnIconglobe-BjPEXYD8.js")),
      TnIconGraph: n(() => import("./TnIcongraph-qYMI19u2.js")),
      TnIconHardOfHearing: n(() => import("./TnIconhard-of-hearing-CYQ2bMkr.js")),
      TnIconHeartFilled: n(() => import("./TnIconheart-filled-BsSZuWMV.js")),
      TnIconHeartOutline: n(() => import("./TnIconheart-outline-D-Anz1s9.js")),
      TnIconHelp: n(() => import("./TnIconhelp-7DnOotoa.js")),
      TnIconHistory: n(() => import("./TnIconhistory-Br5lrn1z.js")),
      TnIconHome: n(() => import("./TnIconhome-B2QUPvl6.js")),
      TnIconHourglass: n(() => import("./TnIconhourglass-DJRcT7UL.js")),
      TnIconHourglassFinished: n(() => import("./TnIconhourglass-finished-G2CUdEc2.js")),
      TnIconHourglassRunning: n(() => import("./TnIconhourglass-running-D5LPwKVs.js")),
      TnIconInfinity: n(() => import("./TnIconinfinity-fMkjZsXX.js")),
      TnIconInfoCircleFilled: n(() => import("./TnIconinfo-circle-filled-pOnsTykF.js")),
      TnIconInfoCircleOutline: n(() => import("./TnIconinfo-circle-outline-BmtwVZfY.js")),
      TnIconInfoStandalone: n(() => import("./TnIconinfo-standalone-CGH3Ujj3.js")),
      TnIconInstagram: n(() => import("./TnIconinstagram-55_J8PtI.js")),
      TnIconIoTSim: n(() => import("./TnIconio-t-sim-DI4Kb5FK.js")),
      TnIconKey: n(() => import("./TnIconkey-BgALDTWb.js")),
      TnIconKeypad: n(() => import("./TnIconkeypad-BZBN1T1V.js")),
      TnIconKroner: n(() => import("./TnIconkroner-Ci1Yyow2.js")),
      TnIconLan: n(() => import("./TnIconlan-DDhZcbBi.js")),
      TnIconLaptop: n(() => import("./TnIconlaptop-DifCX7ZD.js")),
      TnIconLeft: n(() => import("./TnIconleft-DALn0EV8.js")),
      TnIconLightbulb: n(() => import("./TnIconlightbulb-Tu9c2eFC.js")),
      TnIconLink: n(() => import("./TnIconlink-BvjQVT-q.js")),
      TnIconLink2: n(() => import("./TnIconlink-2-CQLep0EM.js")),
      TnIconLinkedIn: n(() => import("./TnIconlinked-in-Bzshp6Z3.js")),
      TnIconLive: n(() => import("./TnIconlive-BpOkYTvU.js")),
      TnIconLocation: n(() => import("./TnIconlocation-BDT1b6pR.js")),
      TnIconLockFilledClosed: n(() => import("./TnIconlock-filled-closed-DNR3LE1Q.js")),
      TnIconLockFilledOpen: n(() => import("./TnIconlock-filled-open-DIlD4t5g.js")),
      TnIconLockOutlineClosed: n(() => import("./TnIconlock-outline-closed-1TPt-elr.js")),
      TnIconLockOutlineOpen: n(() => import("./TnIconlock-outline-open-BT9OeJsC.js")),
      TnIconLog: n(() => import("./TnIconlog-BHOCLyMi.js")),
      TnIconLogIn: n(() => import("./TnIconlog-in--cJqZFEk.js")),
      TnIconLogOut: n(() => import("./TnIconlog-out-CMv10hKH.js")),
      TnIconLongDown: n(() => import("./TnIconlong-down-ByxF1rak.js")),
      TnIconLongLeft: n(() => import("./TnIconlong-left-DWHD8NuU.js")),
      TnIconLongRight: n(() => import("./TnIconlong-right-DZQxcTun.js")),
      TnIconLongUp: n(() => import("./TnIconlong-up-CBXyuhiH.js")),
      TnIconMaximise: n(() => import("./TnIconmaximise-CljSoqAE.js")),
      TnIconMegaphone: n(() => import("./TnIconmegaphone-DHsPR0Bm.js")),
      TnIconMenu: n(() => import("./TnIconmenu-C-xUSlP-.js")),
      TnIconMessage: n(() => import("./TnIconmessage-HF1UdmvL.js")),
      TnIconMicrophoneOff: n(() => import("./TnIconmicrophone-off-C4XfxVuo.js")),
      TnIconMicrophoneOn: n(() => import("./TnIconmicrophone-on-DEbO0Tsc.js")),
      TnIconMicrosoftOffice: n(() => import("./TnIconmicrosoft-office-GSEtAbXF.js")),
      TnIconMinimise: n(() => import("./TnIconminimise-BfIt-dht.js")),
      TnIconMinus: n(() => import("./TnIconminus-Cwp-hOlo.js")),
      TnIconMinusCircleFilled: n(() => import("./TnIconminus-circle-filled-_6VTFNDJ.js")),
      TnIconMinusCircleOutline: n(() => import("./TnIconminus-circle-outline-Dduaq3Uv.js")),
      TnIconMonitor: n(() => import("./TnIconmonitor-WGXqG3Sw.js")),
      TnIconMovieArchive: n(() => import("./TnIconmovie-archive-DA57bR0A.js")),
      TnIconMovieClip: n(() => import("./TnIconmovie-clip-DRd_usEd.js")),
      TnIconMovies: n(() => import("./TnIconmovies-BQOuOZNj.js")),
      TnIconMusic: n(() => import("./TnIconmusic-GrNwKWtw.js")),
      TnIconNearMeOff: n(() => import("./TnIconnear-me-off-BVwUIQnX.js")),
      TnIconNearMeOn: n(() => import("./TnIconnear-me-on-iN9P8PMq.js")),
      TnIconNoBinding: n(() => import("./TnIconno-binding-Dokwh8oa.js")),
      TnIconNotificationFilled: n(() => import("./TnIconnotification-filled-CVW7SXGE.js")),
      TnIconNotificationNew: n(() => import("./TnIconnotification-new-DX4tBNnp.js")),
      TnIconNotificationNone: n(() => import("./TnIconnotification-none-R4f1IjDP.js")),
      TnIconOpeninnewWindow: n(() => import("./TnIconopen-in-new-window-BOF0jx60.js")),
      TnIconOpenPanelLeft: n(() => import("./TnIconopen-panel-left-L5xXbYyU.js")),
      TnIconOpenPanelRight: n(() => import("./TnIconopen-panel-right-Bo9kpgPO.js")),
      TnIconOverflowMenuHorizontal: n(() => import("./TnIconoverflow-menu-horizontal-DFMb3LmE.js")),
      TnIconOverflowMenuVertical: n(() => import("./TnIconoverflow-menu-vertical-CKPr-tSo.js")),
      TnIconPaperclip: n(() => import("./TnIconpaperclip-BZ86GdCy.js")),
      TnIconPaste: n(() => import("./TnIconpaste-DK39TlIn.js")),
      TnIconPause: n(() => import("./TnIconpause-DnGM2sJo.js")),
      TnIconPauseCircleOutline: n(() => import("./TnIconpause-circle-outline-5ibk079W.js")),
      TnIconPauseLarge: n(() => import("./TnIconpause-large-DI7Ts1tF.js")),
      TnIconPendingCircleFilled: n(() => import("./TnIconpending-circle-filled-DIV5x0Hp.js")),
      TnIconPendingCircleOutline: n(() => import("./TnIconpending-circle-outline-D2E9m_G2.js")),
      TnIconPeople: n(() => import("./TnIconpeople-zmSpG0_c.js")),
      TnIconPerson: n(() => import("./TnIconperson-CgN9dn4B.js")),
      TnIconPhoneLandline: n(() => import("./TnIconphone-landline-BdkvltgA.js")),
      TnIconPhoneMobile: n(() => import("./TnIconphone-mobile-Czx36yXB.js")),
      TnIconPhoneReceiver: n(() => import("./TnIconphone-receiver-cS_miPbp.js")),
      TnIconPhoneReceiverFilled: n(() => import("./TnIconphone-receiver-filled-DicP7oJo.js")),
      TnIconPickUp: n(() => import("./TnIconpick-up-DLFJqGC-.js")),
      TnIconPictureInPictureIn: n(() => import("./TnIconpicture-in-picture-in-BpI7zAg-.js")),
      TnIconPictureinPictureOut: n(() => import("./TnIconpicture-in-picture-out-B-S7ygAW.js")),
      TnIconPieChart: n(() => import("./TnIconpie-chart-D7RVZHWp.js")),
      TnIconPlay: n(() => import("./TnIconplay-CRQjhBJB.js")),
      TnIconPlayCircleOutline: n(() => import("./TnIconplay-circle-outline-DLPQErIX.js")),
      TnIconPlayFilled: n(() => import("./TnIconplay-filled-C15sB5Ck.js")),
      TnIconPlayLarge: n(() => import("./TnIconplay-large-DfTGcRx9.js")),
      TnIconPlayOnBox: n(() => import("./TnIconplay-on-box-YSI8tYVy.js")),
      TnIconPlayOnFetch: n(() => import("./TnIconplay-on-fetch-CSXvEnOw.js")),
      TnIconPlus: n(() => import("./TnIconplus-C64Xh5bW.js")),
      TnIconPlusCircleFilled: n(() => import("./TnIconplus-circle-filled-CzeVvqB5.js")),
      TnIconPlusCircleOutline: n(() => import("./TnIconplus-circle-outline-CwhI6n3h.js")),
      TnIconPushPinFilled: n(() => import("./TnIconpush-pin-filled-CArNXpw0.js")),
      TnIconPushPinOutline: n(() => import("./TnIconpush-pin-outline-CqfbNNP5.js")),
      TnIconQr: n(() => import("./TnIconqr-Ceq0XFRd.js")),
      TnIconQuestion: n(() => import("./TnIconquestion-D7CORt3G.js")),
      TnIconQuestionCircleFilled: n(() => import("./TnIconquestion-circle-filled-DntGar9d.js")),
      TnIconQuestionCircleOutline: n(() => import("./TnIconquestion-circle-outline-BGZPl6v7.js")),
      TnIconQueue: n(() => import("./TnIconqueue-BlcD8_FP.js")),
      TnIconRadio: n(() => import("./TnIconradio-CoJGZtZh.js")),
      TnIconRadioButtonChecked: n(() => import("./TnIconradio-button-checked-DMKgjc8t.js")),
      TnIconRadioButtonUnchecked: n(() => import("./TnIconradio-button-unchecked-Bh0UwYUS.js")),
      TnIconRec: n(() => import("./TnIconrec-CmkjK_7c.js")),
      TnIconRecycle: n(() => import("./TnIconrecycle-bFq2JX5o.js")),
      TnIconRedo: n(() => import("./TnIconredo-DrOw4tTG.js")),
      TnIconRefresh: n(() => import("./TnIconrefresh-VniUF1Es.js")),
      TnIconReload: n(() => import("./TnIconreload-Du2LDLsf.js")),
      TnIconRemove: n(() => import("./TnIconremove-kOOu-W_h.js")),
      TnIconRemoveCircleFilled: n(() => import("./TnIconremove-circle-filled-BfokrnGF.js")),
      TnIconRemoveCircleOutline: n(() => import("./TnIconremove-circle-outline-C31SX5Y0.js")),
      TnIconResumeWatching: n(() => import("./TnIconresume-watching-B6pw9kk9.js")),
      TnIconRight: n(() => import("./TnIconright-DMPB1dQe.js")),
      TnIconRouter: n(() => import("./TnIconrouter-D6PWpybM.js")),
      TnIconRouting: n(() => import("./TnIconrouting-BoqpX8VE.js")),
      TnIconSearch: n(() => import("./TnIconsearch-CLnJe1S6.js")),
      TnIconSecurity: n(() => import("./TnIconsecurity-CljYZjbQ.js")),
      TnIconSecurityAlert: n(() => import("./TnIconsecurity-alert-b_mJCSQZ.js")),
      TnIconSecurityOff: n(() => import("./TnIconsecurity-off-z5FdkXYS.js")),
      TnIconSecurityOn: n(() => import("./TnIconsecurity-on-B2tL-0rs.js")),
      TnIconSend: n(() => import("./TnIconsend-DgEtJBdv.js")),
      TnIconSeries: n(() => import("./TnIconseries-DIxvaa9a.js")),
      TnIconSeriesArchive: n(() => import("./TnIconseries-archive-CLqD_ojx.js")),
      TnIconService: n(() => import("./TnIconservice-_amZOWu-.js")),
      TnIconServices: n(() => import("./TnIconservices-D6aIDYSF.js")),
      TnIconSettings: n(() => import("./TnIconsettings-Cj4w74zq.js")),
      TnIconSettingsComplex: n(() => import("./TnIconsettings-complex-ER2a_rI-.js")),
      TnIconShare: n(() => import("./TnIconshare-D7eS5KUQ.js")),
      TnIconShareContent: n(() => import("./TnIconshare-content-BcrqS6Je.js")),
      TnIconSim: n(() => import("./TnIconsim-C_kdkojQ.js")),
      TnIconSkipBack10s: n(() => import("./TnIconskip-back-10s-BS-pIdR9.js")),
      TnIconSkipBackward15s: n(() => import("./TnIconskip-backward-15s-DboWQcLH.js")),
      TnIconSkipBackward30s: n(() => import("./TnIconskip-backward-30s-CPbkQe2d.js")),
      TnIconSkipForward: n(() => import("./TnIconskip-forward-C2EvRsH0.js")),
      TnIconSkipForward10s: n(() => import("./TnIconskip-forward-10s-Bxu972Xj.js")),
      TnIconSkipForward15s: n(() => import("./TnIconskip-forward-15s-DkzaTIoK.js")),
      TnIconSkipForward30s: n(() => import("./TnIconskip-forward-30s-BaSelHPF.js")),
      TnIconSkiptoNext: n(() => import("./TnIconskip-to-next-CYk67P62.js")),
      TnIconSkiptoPrevious: n(() => import("./TnIconskip-to-previous-C81-ta-H.js")),
      TnIconSlack: n(() => import("./TnIconslack-BDRBozlm.js")),
      TnIconSlackNegative: n(() => import("./TnIconslack-negative-BcK8VaHV.js")),
      TnIconSms: n(() => import("./TnIconsms-B4eVtAdi.js")),
      TnIconSort: n(() => import("./TnIconsort-B2ZhqTNx.js")),
      TnIconSortDown: n(() => import("./TnIconsort-down-X5ooU0E8.js")),
      TnIconSortFilled: n(() => import("./TnIconsort-filled-dGbiiR1u.js")),
      TnIconSortHorizontal: n(() => import("./TnIconsort-horizontal-RH34oTF9.js")),
      TnIconSortOutline: n(() => import("./TnIconsort-outline-BhpLolX8.js")),
      TnIconSortUp: n(() => import("./TnIconsort-up-BW2mw_Ku.js")),
      TnIconSoundWave: n(() => import("./TnIconsound-wave-BttxKQDI.js")),
      TnIconSpaceBar: n(() => import("./TnIconspace-bar-CWaDxRVt.js")),
      TnIconSpeakerOff: n(() => import("./TnIconspeaker-off-C39uss7n.js")),
      TnIconSpeakerOn: n(() => import("./TnIconspeaker-on-iy98uUq0.js")),
      TnIconSpinner: n(() => import("./TnIconspinner-lRSkzl-7.js")),
      TnIconSplit: n(() => import("./TnIconsplit-CqpihsbJ.js")),
      TnIconSport: n(() => import("./TnIconsport-C5aNrE-s.js")),
      TnIconStarFilled: n(() => import("./TnIconstar-filled-BPohIvny.js")),
      TnIconStarOutline: n(() => import("./TnIconstar-outline-DMEhL-4O.js")),
      TnIconStartOver: n(() => import("./TnIconstart-over-B2oTyJNn.js")),
      TnIconStop: n(() => import("./TnIconstop-Ct4Q19_Y.js")),
      TnIconStorage: n(() => import("./TnIconstorage-MeEWO6P2.js")),
      TnIconStorybook: n(() => import("./TnIconstorybook-BPYqNX8_.js")),
      TnIconStorybookNegative: n(() => import("./TnIconstorybook-negative-D3mTU5uT.js")),
      TnIconSubdirectoryLeft: n(() => import("./TnIconsubdirectory-left-Ri6AqTWt.js")),
      TnIconSubdirectoryRight: n(() => import("./TnIconsubdirectory-right-hkbs_ol6.js")),
      TnIconSubscription: n(() => import("./TnIconsubscription-DGhp0GxL.js")),
      TnIconSubtitles: n(() => import("./TnIconsubtitles-CRFgXqPy.js")),
      TnIconSuccess: n(() => import("./TnIconsuccess-B6h8czRd.js")),
      TnIconSuccessCircleFilled: n(() => import("./TnIconsuccess-circle-filled-D8z8UrPi.js")),
      TnIconSuccessCircleOutline: n(() => import("./TnIconsuccess-circle-outline-BqTOGpR7.js")),
      TnIconTag: n(() => import("./TnIcontag-DYfEPm5G.js")),
      TnIconTagFilled: n(() => import("./TnIcontag-filled-CasbEcw2.js")),
      TnIconTelegrafen: n(() => import("./TnIcontelegrafen-BDnHDM0j.js")),
      TnIconTelegrafen1px: n(() => import("./TnIcontelegrafen-1px-BF7wSN2C.js")),
      TnIconTelenor: n(() => import("./TnIcontelenor-DaryT9tO.js")),
      TnIconTelenorNegative: n(() => import("./TnIcontelenor-negative-dgSMgsgM.js")),
      TnIconThumbsDownFilled: n(() => import("./TnIconthumbs-down-filled-4XL13hwB.js")),
      TnIconThumbsDownOutline: n(() => import("./TnIconthumbs-down-outline-CMMVb40f.js")),
      TnIconThumbsUpFilled: n(() => import("./TnIconthumbs-up-filled-B9wJlRIB.js")),
      TnIconThumbsUpOutline: n(() => import("./TnIconthumbs-up-outline-CwFOyDXI.js")),
      TnIconTickets: n(() => import("./TnIcontickets-D1FK3akD.js")),
      TnIconTimer: n(() => import("./TnIcontimer-C-43J_Cn.js")),
      TnIconTrashcan: n(() => import("./TnIcontrashcan-BtxHJylI.js")),
      TnIconTrashcanOpen: n(() => import("./TnIcontrashcan-open-CY37Cl36.js")),
      TnIconTrendingDown: n(() => import("./TnIcontrending-down-BqCKOTdH.js")),
      TnIconTrendingStable: n(() => import("./TnIcontrending-stable-BPdlGL_Y.js")),
      TnIconTrendingUp: n(() => import("./TnIcontrending-up-B8X4pd7V.js")),
      TnIconTv: n(() => import("./TnIcontv-CK3dGiKp.js")),
      TnIconTvArchive: n(() => import("./TnIcontv-archive-ChYwInQE.js")),
      TnIconTvGuide: n(() => import("./TnIcontv-guide-DhM9-TLV.js")),
      TnIconTWeBox: n(() => import("./TnIcont-we-box-DxGfZ_Fb.js")),
      TnIconTwitterLegacy: n(() => import("./TnIcontwitter-legacy-0h7TIAbF.js")),
      TnIconUnavailable: n(() => import("./TnIconunavailable-DKjq575-.js")),
      TnIconUndo: n(() => import("./TnIconundo-z4BW-nbB.js")),
      TnIconUp: n(() => import("./TnIconup-CcUVJ6Ra.js")),
      TnIconUploadTray: n(() => import("./TnIconupload-tray-DJfB0nWx.js")),
      TnIconVideocameraOn: n(() => import("./TnIconvideocamera-on-C-52qbTa.js")),
      TnIconVideoOnDemand: n(() => import("./TnIconvideo-on-demand-Ddd6oAki.js")),
      TnIconViewCard: n(() => import("./TnIconview-card-CjgJIGEQ.js")),
      TnIconViewHorizontalCard: n(() => import("./TnIconview-horizontal-card-DGKLwPXQ.js")),
      TnIconViewList: n(() => import("./TnIconview-list-C4rrWuSW.js")),
      TnIconViewTable: n(() => import("./TnIconview-table-7n7pISYw.js")),
      TnIconVipps: n(() => import("./TnIconvipps-D0Y5Zneu.js")),
      TnIconVippsApp: n(() => import("./TnIconvipps-app-B1PcEj_K.js")),
      TnIconVippsAppNegative: n(() => import("./TnIconvipps-app-negative-CotlKuyb.js")),
      TnIconVoicemail: n(() => import("./TnIconvoicemail-BAX9MVvj.js")),
      TnIconWarningCircleFilled: n(() => import("./TnIconwarning-circle-filled-Gf30XLwA.js")),
      TnIconWarningCircleOutline: n(() => import("./TnIconwarning-circle-outline-DdHru5qg.js")),
      TnIconWatch: n(() => import("./TnIconwatch-CUlvmJG1.js")),
      TnIconWeeklyArchive: n(() => import("./TnIconweekly-archive-Cw8ODoCb.js")),
      TnIconWiFi: n(() => import("./TnIconwi-fi-BJrH0H2R.js")),
      TnIconWizard: n(() => import("./TnIconwizard-BZ9HwIID.js")),
      TnIconX: n(() => import("./TnIconx-DN_gymBj.js")),
      TnIconYouTube: n(() => import("./TnIconyou-tube-DGGUKH2V.js")),
      TnIconZoomIn: n(() => import("./TnIconzoom-in-40P3nBUc.js")),
      TnIconZoomOut: n(() => import("./TnIconzoom-out-la3HNy3-.js"))
    }, m = p(() => {
      if (!o.name) return null;
      const i = Object.keys(r).find((c) => c.toLowerCase() === `tnicon${o.name.toLowerCase().replace(/-/g, "")}`);
      return i ? r[i] : null;
    });
    return (i, c) => (I(), l(a(m.value), {
      height: t.value,
      width: t.value,
      fill: i.color
    }, null, 8, ["height", "width", "fill"]));
  }
});
export {
  u as TnIcon
};
